<script lang="ts">
  import { Slider } from "carbon-components-svelte";

  export let value: number;
  export let min: number;
  export let max: number;
  export let step: number;
  export let labelText: string;
</script>

<div class="flex-wrap">
  <div class="slider-value">
    {value}
  </div>
  <Slider {labelText} {min} {max} {step} bind:value on:change hideTextInput />
</div>
